@if (show()) {
  <p>{{message()}}</p>
}